import React from 'react';
import "./styles.css";

function HeroSection() {
return (
    <div className="hero-section">
        <div className="hero-left">
            <div className="hero-banner">
                <img src="/images/mainpage/logo.png" alt="Teamwork Logo" className="logo" />
                <span className="text-yellow">Teamwork</span>
                <span className="text-green">Nation</span>
            </div>
            <p className="hero-subtext">
                Where <span className="text-yellow">Teamwork</span> meets Imagi
                <span className="text-green">Nation</span>
            </p>
            <div className="hero-buttons">
                <button onClick={() => window.location.href = "/login"}>Sign In</button>
                <button onClick={() => window.location.href = "/learn-more"}>Learn More</button>
            </div>
        </div>
        <div className="hero-right">
            <div className="teams-text-wrapper text-yellow">  
                <h2 className="teams-heading-overlay">We're All About</h2>  
                   
                <div className="image-overlay-wrapper">
                     <img
                        src="/images/mainpage/whitebrushstroke.png"
                        alt="Teamwork"
                        className="teams-background"
                    />

                    <div className="teams-overlay-content">
                        <div className="team-letter">
                            <span className="letter">T</span><span className="rest">echnology</span>
                        </div>
                        <div className="team-letter">
                            <span className="letter">E</span><span className="rest">ngineering</span>
                        </div>
                        <div className="team-letter">
                            <span className="letter">A</span><span className="rest">rt</span>
                        </div>
                        <div className="team-letter">
                            <span className="letter">M</span><span className="rest">ath</span>
                        </div>
                        <div className="team-letter">
                            <span className="letter">S</span><span className="rest">cience</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
}

export default HeroSection;
